import {
    ChangeDetectionStrategy,
    Component,
    input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core'
import { Field } from '@models/ui'
import { SelectOption } from '@core/models'
import { values } from 'lodash-es'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'

@Component({
    selector: 'app-status-section-content',
    imports: [TbIconComponent],
    templateUrl: './status-section-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusSectionContentComponent implements OnInit, OnChanges {
    readonly field = input.required<Field>()

    selectOptions: SelectOption[] = []

    ngOnInit() {
        this.setSelectOptions()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.field.firstChange) return
        this.setSelectOptions()
    }

    private setSelectOptions() {
        if (this.field().select_object_field_sorted) {
            this.selectOptions = this.field().select_object_field_sorted!
        } else {
            this.selectOptions = values(this.field().select_object_field!)
        }
    }
}
